module.exports = "/images/cta-bg.jpg?90e63cc6bbec4b423dd02d6254cf4e4e";